/**
 * True when the browser/Axios cancelled the request (e.g. NS_BINDING_ABORTED),
 * not when it failed with a normal network or HTTP error.
 */
export function isRequestAborted(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false

  const err = error as {
    code?: string
    name?: string
    message?: string
  }

  if (err.code === 'ERR_CANCELED') return true
  if (err.name === 'CanceledError' || err.name === 'AbortError') return true

  const message = String(err.message || '')
  if (/NS_BINDING_ABORTED/i.test(message)) return true
  if (/^canceled$/i.test(message) || /^cancelled$/i.test(message)) return true

  return false
}
